import React, { useState, useEffect } from "react";
import "./MenuLateral.css";
import "./SpeedDial.css";
import axios from "../../hooks/fetchWithAuth";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import WidgetsIcon from "@mui/icons-material/Widgets";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import HelpIcon from '@mui/icons-material/Help';
import ReviewsIcon from "@mui/icons-material/Reviews";
import ArchiveIcon from "@mui/icons-material/Archive";
import TuneIcon from "@mui/icons-material/Tune";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import BackgroundColorPicker from "../BackgroundColorPicker/BackgroundColorPicker";
import Alerts2 from "../Alert2";
import config from "../../config";
import HelpMenu from "./menus/HelpMenu";
import MembersModal from "./menus/MembersModal";
import EditBoardMenu from "./menus/EditBoardMenu";
import PermissionsMenu from "./menus/PermissionsMenu";
import getCookie from "../../hooks/getCookie";
import setCookie from "../../hooks/setCookie";
import Checkbox from "@mui/material/Checkbox";
import CryptoJS from "crypto-js";
import { styled, useTheme } from "@mui/material/styles";

export default function MenuLateral({
  boardId,
  boardBackgroundColor,
  setBoardBackgroundColor,
  toggleArchiveList,
  showArchiveList,
}) {
  const backendIp = config.backend_ip;
  const [backgroundPickerOpen, setBackgroundPickerOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark")
  );
  const [collapsed, setCollapsed] = useState(true);
  const [alert2, setAlert2] = React.useState(null);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);
  const [membersDialogOpen, setMembersDialogOpen] = useState(false);
  const [permissaoDialogOpen, setPermissaoDialogOpen] = useState(false);
  const [editBoardDialogOpen, setEditBoardDialogOpen] = useState(false);
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [boardMembers, setBoardMembers] = useState([]);
  const [boards, setBoards] = useState([]);
  const userId = getCookie("userId");
  const permissao = getCookie("permissao");
  const username = getCookie("username");
  const sessionId = getCookie("session_id");
  const [description, setDescription] = useState("");
  const [anchorElTitle, setAnchorElTitle] = useState(null);
  const [anchorElDescription, setAnchorElDescription] = useState(null);
  const handleCloseTitle = () => setAnchorElTitle(null);
  const handleCloseDescription = () => setAnchorElDescription(null);
  const [alert, setAlert] = React.useState(null);
  const handleClickTitle = (event) => setAnchorElTitle(event.currentTarget);
  const handleClickDescription = (event) =>
    setAnchorElDescription(event.currentTarget);
  const openTitle = Boolean(anchorElTitle);
  const openDescription = Boolean(anchorElDescription);

  const [title, setTitle] = useState("");
  const decryptData = (data) => {
    const bytes = CryptoJS.AES.decrypt(data, "secret-key");
    return bytes.toString(CryptoJS.enc.Utf8);
  };
  const handleToggleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  const ou = decryptData(localStorage.getItem("ou"));

  const updateBoardBackground = async (background) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/update_board_background`, {
        board_id: boardId,
        background_color: background,
      });
      setBoardBackgroundColor(background);
      setAlert2({
        message: "Cor de fundo atualizada com sucesso!",
        severity: "success",
      });
      setTimeout(() => setAlert2(null), 3000);
    } catch (error) {
      setAlert2({
        message: "Erro ao atualizar cor de fundo",
        severity: "error",
      });
      setTimeout(() => setAlert2(null), 3000);
    }
  };

  const handleTuneIconClick = () => {
    setBackgroundPickerOpen(true);
  };

  const handleBackgroundPickerClose = () => {
    setBackgroundPickerOpen(false);
  };

  const getTextColor = (hexColor) => {
    if (!hexColor) return "#000"; // fallback
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? "#000" : "#fff";
  };
  const textColor = getTextColor(
    boardBackgroundColor || (isDarkMode ? "#1e1e1e" : "#f2f2f2")
  );

  useEffect(() => {
    fetchMembers();
    fetchBoardMembers();
    fetchBoards();
    setCookie("permissao", permissao);
  }, []);

  const fetchBoards = async () => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/list_current_board`,
        {
          board_id: boardId,
          user: username,
          session_id: sessionId,
        }
      );
      setBoards(response.data);
    } catch (error) {
      return null;
    }
  };

  const fetchMembers = async () => {
    try {
      // Buscar membros apenas da mesma OU do usuário
      const response = await axios.get(
        `${backendIp}/api/board/ti/list_users_ou?ou=${ou}`
      );
      setMembers(response.data);
      setFilteredMembers(response.data);
    } catch (error) {
      return null;
    }
  };

  const fetchBoardMembers = async () => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/list_users_in_board`,
        {
          board_id: boardId,
          user: username,
          session_id: sessionId,
        }
      );
      setBoardMembers(response.data);
    } catch (error) {
      return null;
    }
  };

  const handleHelpDialogOpen = () => {
    setHelpDialogOpen(true);
  };

  const handleHelpDialogClose = () => {
    setHelpDialogOpen(false);
  };

  const handleMembersDialogOpen = () => {
    setMembersDialogOpen(true);
  };

  const handleMembersDialogClose = () => {
    setMembersDialogOpen(false);
  };

  const handlePermissaoDialogOpen = () => {
    setPermissaoDialogOpen(true);
  };

  const handlePermissaoDialogClose = () => {
    setPermissaoDialogOpen(false);
  };

  const handleEditBoardDialogOpen = () => {
    setEditBoardDialogOpen(true);
  };

  const handleEditBoardDialogClose = () => {
    setEditBoardDialogOpen(false);
  };

  const handleTitleSubmit = async () => {
    try {
      await axios.put(`${backendIp}/api/board/ti/update_board_name`, {
        board_id: boardId,
        board_name: title,
      });
      fetchBoards();
      handleCloseTitle();
    } catch (error) {
      return null;
    }
  };

  const handleDescriptionSubmit = async () => {
    try {
      await axios.put(`${backendIp}/api/board/ti/update_board_description`, {
        board_id: boardId,
        board_description: description,
      });
      fetchBoards();
      handleCloseDescription();
    } catch (error) {
      return null;
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setFilteredMembers(
      members.filter((member) =>
        member.nome_completo.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const CustomCheckbox = styled(Checkbox)({
    "& .MuiIconButton-root": {
      border: "none", // Remove a borda ao redor do checkbox
    },
    "&:hover": {
      backgroundColor: "transparent", // Remove o fundo ao passar o mouse
    },
  });

  const handleCheckboxChange = (userId, checked) => {
    if (checked) {
      // Adiciona o membro selecionado ao estado
      setSelectedMembers((prevSelected) => [...prevSelected, userId]);
    } else {
      // Remove o membro desmarcado do estado
      setSelectedMembers((prevSelected) =>
        prevSelected.filter((id) => id !== userId)
      );
    }
  };

  const handleUpdatePermission = async (user_id) => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/update_user_permission`,
        {
          board_id: boardId,
          user_id: user_id,
        }
      );
      fetchMembers();
      fetchBoardMembers();
      // Define o alerta de sucesso
      setAlert({
        message: "Permissão adicionado com sucesso!",
        severity: "success",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert({
        message: "Erro ao adicionar nova permissão",
        severity: "error",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    }
  };

  const handleRemovePermission = async (user_id) => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/remove_user_permission`,
        {
          board_id: boardId,
          user_id: user_id,
        }
      );
      fetchMembers();
      fetchBoardMembers();
      // Define o alerta de sucesso
      setAlert({
        message: "Permissão removida com sucesso!",
        severity: "success",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert({ message: "Erro ao remover permissão", severity: "error" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    }
  };

  const handleSaveChanges = async () => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/add_user_in_board`,
        {
          userIds: selectedMembers,
          board_id: boardId,
          userId: userId,
        }
      );
      setSelectedMembers([]);
      fetchMembers();
      fetchBoardMembers();

      // Define o alerta de sucesso
      setAlert({
        message: "Usuário(s) adicionado(s) ao quadro com sucesso!",
        severity: "success",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert({
        message: "Erro ao adicionar usuário(s) ao quadro",
        severity: "error",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    }
  };

  const handleRemoveChanges = async () => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/remove_user_of_board`,
        {
          userIds: selectedMembers,
          board_id: boardId,
          userId: userId,
        }
      );
      setSelectedMembers([]);
      fetchMembers();
      fetchBoardMembers();
      // Define o alerta de sucesso
      setAlert({
        message: "Usuário(s) removido(s) do quadro com sucesso!",
        severity: "success",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert({
        message: "Erro ao remover usuário(s) do quadro",
        severity: "error",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    }
  };

  const handleToggleArchive = () => {
    toggleArchiveList();
  };

  return (
    <>
      <div
        className={`menu-direito ${collapsed ? "collapsed" : ""}`}
        onMouseOver={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}
      >
        <ul className="ul-menu-direito text-navbar-options">
          <MenuItem
            sx={{ color: textColor }}
            onClick={handleTuneIconClick}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <TuneIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Ajustes do Quadro" />
          </MenuItem>
          <MenuItem
            sx={{ color: textColor }}
            onClick={handleToggleArchive}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <ArchiveIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Arquivados" />
          </MenuItem>
          {(permissao === "dono" || permissao === "admin") && (
            <>
              <MenuItem
                sx={{ color: textColor }}
                onClick={handleMembersDialogOpen}
                className="text-navbar-options"
              >
                <ListItemIcon>
                  <PeopleAltIcon
                    sx={{ color: textColor }}
                    className="text-navbar-options"
                  />
                </ListItemIcon>
                <ListItemText primary="Membros" />
              </MenuItem>

              <MenuItem
                sx={{ color: textColor }}
                onClick={handlePermissaoDialogOpen}
                className="text-navbar-options"
              >
                <ListItemIcon>
                  <BadgeIcon
                    sx={{ color: textColor }}
                    className="text-navbar-options"
                  />
                </ListItemIcon>
                <ListItemText primary="Permissões" />
              </MenuItem>
              <MenuItem
                sx={{ color: textColor }}
                onClick={handleEditBoardDialogOpen}
                className="text-navbar-options"
              >
                <ListItemIcon>
                  <AppRegistrationIcon
                    sx={{ color: textColor }}
                    className="text-navbar-options"
                  />
                </ListItemIcon>
                <ListItemText primary="Editar Quadro" />
              </MenuItem>
            </>
          )}
          <MenuItem
            sx={{ color: textColor }}
            onClick={handleHelpDialogOpen}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <HelpIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Ajuda" />
          </MenuItem>
        </ul>
      </div>
      <BackgroundColorPicker
        open={backgroundPickerOpen}
        onClose={handleBackgroundPickerClose}
        currentColor={boardBackgroundColor}
        onColorChange={updateBoardBackground}
      />
      {editBoardDialogOpen == true && (
        <EditBoardMenu
          boards={boards}
          openTitle={openTitle}
          openDescription={openDescription}
          anchorElTitle={anchorElTitle}
          anchorElDescription={anchorElDescription}
          handleClickTitle={handleClickTitle}
          handleClickDescription={handleClickDescription}
          handleCloseTitle={handleCloseTitle}
          handleCloseDescription={handleCloseDescription}
          handleTitleSubmit={handleTitleSubmit}
          handleDescriptionSubmit={handleDescriptionSubmit}
          setTitle={setTitle}
          setDescription={setDescription}
          handleEditBoardDialogClose={handleEditBoardDialogClose}
        />
      )}
      {membersDialogOpen == true && (
        <MembersModal
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          handleSaveChanges={handleSaveChanges}
          filteredMembers={filteredMembers}
          boardMembers={boardMembers}
          selectedMembers={selectedMembers}
          handleCheckboxChange={handleCheckboxChange}
          CustomCheckbox={CustomCheckbox}
          handleMembersDialogClose={handleMembersDialogClose}
          handleRemoveChanges={handleRemoveChanges}
        />
      )}
      {helpDialogOpen == true && (
        <HelpMenu handleHelpDialogClose={handleHelpDialogClose} />
      )}

      {permissaoDialogOpen == true && (
        <PermissionsMenu
          filteredMembers={filteredMembers}
          boardMembers={boardMembers}
          username={username}
          handleRemovePermission={handleRemovePermission}
          handleUpdatePermission={handleUpdatePermission}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          handlePermissaoDialogClose={handlePermissaoDialogClose}
        />
      )}

      {alert2 && (
        <Alerts2 message={alert2.message} severity={alert2.severity} />
      )}
    </>
  );
}
